<template lang="pug">
  .card.height-100
    .card-body
      .columns.align-center
        .column.col-auto
          user-avatar.avatar-lg(:user="filiation.person")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ filiation.person.fullName }}
          .text-small.text-ellipsis {{ filiation.person.email }}
          .text-small
            | Autor:
            router-link.btn.btn-link.btn-sm(:to="{ name: 'filiations.list.setAuthor', params: { id: filiation.id } }")
              span.text-bold(v-if="filiation.author")  {{ filiation.author.name }}
              span(v-else)
                | &nbsp;
                i.fas.fa-link
                |  Clique para vincular um autor
      .divider
      div
      .text-small
        small Percentuais de ganho:
      .text-small
        span Assinatura:
        b(v-if="filiation.subscriptionPercentage")  {{ filiation.subscriptionPercentage | currency('', ' %') }}
        b(v-else)  Padrão
      .text-small
        span Compras:
        b(v-if="filiation.purchasePercentage")  {{ filiation.purchasePercentage | currency('', ' %') }}
        b(v-else)  Padrão
      router-link.text-small.c-hand(:to="{ name: 'filiations.list.editPercentages', params: { id: filiation.id } }")
        small
          i.fas.fa-edit
          |  Editar percentuais
      .divider
    .card-footer
      .columns.align-center
        .column
          .text-small Afiliado em #[span.text-bold {{ filiation.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          .text-ellipsis.d-flex.align-center
            .mr-2 {{ filiation.active ? 'Ativo' : 'Inativo' }}
            .form-group
              label.form-switch
                input(type="checkbox" @change="$emit('change-active', { filiation, active })" v-model="active")
                i.form-icon
        .column.col-auto
          router-link.btn.btn-sm.btn-link.tooltip.tooltip-left(:to="{ name: 'filiations.show', params: { id: filiation.id } }" data-tooltip="Exibir")
            i.fas.fa-eye
</template>

<script>
export default {
  props: {
    filiation: { type: Object, required: true },
  },
  data() {
    return { active: false }
  },
  created() {
    this.active = this.filiation.active
  },
}
</script>
